export default __webpack_public_path__ + "static/media/ic_comparative.2bac4b20.svg";